<template>
  <v-form v-model="formValid" ref="databaseConfigForm">
    <v-row>
      <v-col cols="12" md="12" sm="12">
        <p class="input-label text-style dark--text mb-0 mt-5">Select Database</p>
        <v-select
          v-model="databaseType"
          :items="databaseTypes"
          item-text="text"
          item-value="value"
          item-disabled="disabled"
          :menu-props="{ offsetY: true }"
          class="select-field"
          hide-details
          :rules="[rules.required]"
        />
      </v-col>
      <template v-if="databaseType">
        <v-col cols="12" md="12" sm="12">
          <v-checkbox
            v-model="useCustomConnectionString"
            color="primary"
            class="input-label text-style dark--text"
            label="Custom connection string"
            hide-details
          />
          <v-text-field
            v-model="connectionString"
            class="select-field"
            v-if="useCustomConnectionString"
            :rules="useCustomConnectionString ? [rules.required, this.validateConnectionString] : []"
          />
        </v-col>
        <v-col cols="12" md="9" sm="12">
          <p class="input-label text-style dark--text mb-0 mt-5">Host</p>
          <v-text-field
            hint="172.156.1.1, 172.156.1.2"
            v-model="config.host"
            :disabled="useCustomConnectionString"
            class="select-field"
            hide-details
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" md="3" sm="12">
          <p class="input-label text-style dark--text mb-0 mt-5">Port</p>
          <v-text-field
            v-model="config.port"
            :disabled="useCustomConnectionString"
            class="select-field"
            hide-details
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <p class="input-label text-style dark--text mb-0 mt-5">Username</p>
          <v-text-field
            v-model="config.username"
            :disabled="useCustomConnectionString"
            class="select-field"
            hide-details
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <p class="input-label text-style dark--text mb-0 mt-5">Password</p>
          <v-text-field
            v-model="config.password"
            :disabled="useCustomConnectionString"
            class="select-field"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <p class="input-label text-style dark--text mb-0 mt-5">Database</p>
          <v-text-field
            v-model="config.database"
            :disabled="useCustomConnectionString"
            class="select-field"
            hide-details
          />
        </v-col>
        <v-col cols="12" md="6" sm="12">
          <p class="input-label text-style dark--text mb-0 mt-5">SSL Mode</p>
          <v-select
            v-model="config.ssl_mode"
            :items="sslModes"
            item-text="text"
            item-value="value"
            item-disabled="disabled"
            :disabled="useCustomConnectionString"
            :menu-props="{ offsetY: true }"
            class="select-field"
            hide-details
          />
        </v-col>
      </template>
    </v-row>
  </v-form>
</template>

<script>
import { DATABASE_TYPES } from './data'

export default {
  name: 'DatabaseConfig',
  props: ['dbConfig'],
  data () {
    return {
      sslModes: [
        {
          text: 'Disabled',
          value: 'none'
        },
        {
          text: 'Prefer SSL if supported',
          value: 'Preferred'
        },
        {
          text: 'Force SSL',
          value: 'Required'
        }
      ],
      useCustomConnectionString: false,
      customConnectionString: '',
      databaseType: '',
      databaseTypes: DATABASE_TYPES,
      config: { ssl_mode: 'Preferred' },
      formValid: false,
      rules: {
        required: (v) => !!v || 'Field is Required'
      }
    }
  },
  methods: {
    validateConnectionString () {
      const requiredProperties = ['host', 'port', 'username']
      for (const prop of requiredProperties) {
        if (!this.config[prop]) {
          return 'Missing required property: ' + prop
        }
      }
      return true
    },
    parseMySQLConnectionString (val) {
      const config = { ssl_mode: 'Preferred' }
      val.split(';').map((param) => {
        if (param.split('=').length === 2) {
          let [key, value] = param.split('=')
          key = key.trim().toLowerCase()
          value = value.trim()
          if (key === 'server') {
            config.host = value
          } else if (key === 'port') {
            config.port = value
          } else if (key === 'uid') {
            config.username = value
          } else if (key === 'pwd') {
            config.password = value
          } else if (key === 'database') {
            config.database = value
          } else if (key === 'sslmode') {
            config.ssl_mode = value
          }
        }
      })
      return config
    },
    buildMySQLConnectionString () {
      let connString = ''
      connString += `Server=${this.config.host};`
      connString += `Port=${this.config.port};`
      connString += `Uid=${this.config.username};`
      if (this.config.password) {
        connString += `Pwd=${this.config.password};`
      }
      if (this.config.database) {
        connString += `Database=${this.config.database};`
      }
      if (this.config.ssl_mode) {
        connString += `SslMode=${this.config.ssl_mode};`
      }
      return connString
    },
    parseMSSQLConnectionString (val) {
      const config = { ssl_mode: 'none' }
      val.split(';').map((param) => {
        if (param.split('=').length === 2) {
          let [key, value] = param.split('=')
          key = key.trim().toLowerCase()
          value = value.trim()
          if (key === 'server' || key === 'data source' || key === 'address' || key === 'addr' || key === 'network address') {
            const values = value.split(',')
            if (values.length > 1) {
              config.host = value.split(',').slice(0, -1).join(',')
              config.port = parseInt(values[values.length - 1])
            } else {
              config.host = value
              config.port = 1433
            }
          } else if (key === 'user id' || key === 'uid' || key === 'user') {
            config.username = value
          } else if (key === 'password' || key === 'pwd') {
            config.password = value
          } else if (key === 'database' || key === 'initial catalog') {
            config.database = value
          } else if (key === 'encrypt') {
            if (value.toLowerCase() === 'yes' || value.toLowerCase() === 'true') {
              config.ssl_mode = 'Preferred'
            }
          }
        }
      })
      return config
    },
    buildMSSQLConnectionString () {
      let connString = ''
      connString += `Server=${this.config.host},${this.config.port};`
      connString += `Uid=${this.config.username};`
      if (this.config.password) {
        connString += `Pwd=${this.config.password};`
      }
      if (this.config.database) {
        connString += `Database=${this.config.database};`
      }
      if (this.config.ssl_mode == 'Preferred' || this.config.ssl_mode == 'Required') {
        connString += 'Encrypt=yes;'
      }
      return connString
    }
  },
  computed: {
    connectionString: {
      cache: false,
      get () {
        if (!this.useCustomConnectionString) {
          if (this.databaseType === 'mysql') {
            return this.buildMySQLConnectionString()
          } else if (this.databaseType === 'mssql') {
            return this.buildMSSQLConnectionString()
          }
        } else {
          return this.customConnectionString
        }
      },
      set (val) {
        let config
        if (this.databaseType === 'mysql') {
          config = this.parseMySQLConnectionString(val)
        } else if (this.databaseType === 'mssql') {
          config = this.parseMSSQLConnectionString(val)
        }

        this.config = config
        this.customConnectionString = val
      }
    }
  },
  mounted () {
    if (this.dbConfig) {
      this.databaseType = this.dbConfig.provider
      this.useCustomConnectionString = true
      let connStr = this.dbConfig.connectionString
      connStr = connStr.replace(/^(connection_string=)/, '')
      this.connectionString = connStr
    }
  },
  watch: {
    databaseType (val) {
      this.$emit('dbConfigUpdated', { provider: val })
    },
    config: {
      handler (val) {
        this.$emit('dbConfigUpdated', { config: val })
      },
      deep: true
    },
    connectionString (val) {
      this.$emit('dbConfigUpdated', { connectionString: val })
    },
    formValid (val) {
      this.$emit('dbConfigUpdated', { valid: val })
    }
  }
}
</script>

<style scoped>
.MyNetworkDatabase {
  font-size: 13px;
  font-weight: 600;
  border: 1px dashed #ccc;
  padding: 15px;
  color: #666;
  text-align: center;
  margin: 25px 0;
}
</style>
